import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api.ts";
import type { DocumentSeriesOut } from "@/types/api.ts";

export const branchKeys = {
  all: ["branches"] as const,
  series: (branchId: string) => [...branchKeys.all, branchId, "series"] as const,
};

export function useBranchSeries(branchId: string | null | undefined) {
  return useQuery({
    queryKey: branchKeys.series(branchId ?? ""),
    queryFn: () =>
      api.get<DocumentSeriesOut[]>(`/branches/${branchId}/series`, {
        searchParams: { only_active: true },
      }),
    enabled: !!branchId,
    staleTime: 60_000,
  });
}
